<template>
  <section class="blog-saved-bar" aria-label="Acesso à coleção de publicações salvas">
    <div class="blog-saved-bar__inner">
      <form class="blog-saved-bar__search" role="search" @submit.prevent="submitSearch">
        <label class="sr-only" for="blog-saved-search-input">Buscar matérias do blog</label>
        <v-icon class="blog-saved-bar__search-icon" small>mdi-magnify</v-icon>
        <input
          id="blog-saved-search-input"
          v-model="term"
          type="search"
          maxlength="80"
          autocomplete="off"
          placeholder="Buscar matérias…"
          @input="onInput"
        />
        <button
          v-if="term"
          type="button"
          class="blog-saved-bar__clear"
          aria-label="Limpar busca"
          @click="clearSearch"
        >
          Limpar
        </button>
      </form>

      <router-link
        to="/portal-zinnes/salvos"
        class="blog-saved-bar__button"
        aria-label="Abrir publicações salvas"
      >
        <v-icon class="blog-saved-bar__icon" small aria-hidden="true">mdi-bookmark-multiple</v-icon>
        <span class="blog-saved-bar__label">Salvos</span>
      </router-link>
    </div>
  </section>
</template>

<script>
export default {
  name: "BlogSavedBar",
  props: {
    query: { type: String, default: "" },
  },
  data: () => ({ term: "", debounceTimer: null }),
  watch: {
    query(value) {
      if (this.term !== value) this.term = value || "";
    },
  },
  methods: {
    onInput() {
      if (this.debounceTimer) clearTimeout(this.debounceTimer);
      this.debounceTimer = setTimeout(() => this.$emit("search", this.term), 250);
    },
    submitSearch() {
      if (this.debounceTimer) clearTimeout(this.debounceTimer);
      this.$emit("search", this.term);
    },
    clearSearch() {
      this.term = "";
      this.$emit("search", "");
    },
  },
  beforeDestroy() {
    if (this.debounceTimer) clearTimeout(this.debounceTimer);
  },
};
</script>
